(function () {
  'use strict';

  function initBlogSearch(sectionRoot) {
    if (!sectionRoot) return;

    /*
     * Verhindert doppelte Initialisierung.
     * Wichtig z. B. im Shopify Theme Editor.
     */
    if (sectionRoot.dataset.blogSearchInitialized === 'true') {
      return;
    }

    const searchWrapper =
      sectionRoot.querySelector('[data-blog-search]');

    if (!searchWrapper) {
      return;
    }

    const searchInput =
      searchWrapper.querySelector('[data-blog-search-input]');

    const clearButton =
      searchWrapper.querySelector('[data-blog-search-clear]');

    const statusElement =
      searchWrapper.querySelector('[data-blog-search-status]');

    const resultsContainer =
      sectionRoot.querySelector('[data-blog-results]');

    const paginationControls =
      sectionRoot.querySelector('[data-blog-pagination-controls]');

    const featuredCard =
      sectionRoot.querySelector('[data-blog-featured]');

    if (
      !searchInput ||
      !clearButton ||
      !resultsContainer
    ) {
      return;
    }

    sectionRoot.dataset.blogSearchInitialized = 'true';

    const blogUrl =
      searchWrapper.dataset.blogUrl;


    /*
     * ==================================================
     * ORIGINALZUSTAND
     * ==================================================
     */

    let originalResultsHTML = '';

    let originalFeaturedDisplay = '';

    let originalPaginationDisplay = '';

    let searchIsActive = false;


    function captureOriginalState() {
      originalResultsHTML =
        resultsContainer.innerHTML;

      if (featuredCard) {
        originalFeaturedDisplay =
          featuredCard.style.display;
      }

      if (paginationControls) {
        originalPaginationDisplay =
          paginationControls.style.display;
      }
    }


    /*
     * ==================================================
     * BLOG INDEX
     * ==================================================
     */

    let blogIndex = [];

    let indexLoaded = false;

    let indexLoading = false;

    let loadingPromise = null;

    /*
     * Schutz vor alten asynchronen Suchanfragen.
     */
    let searchVersion = 0;


    /*
     * ==================================================
     * TEXT NORMALISIEREN
     * ==================================================
     */

    function normalizeText(text) {
      return String(text || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    }


    /*
     * ==================================================
     * BILDER AKTIVIEREN
     * ==================================================
     */

    function activateBlogImages(container) {
      if (!container) {
        return;
      }

      container
        .querySelectorAll('img')
        .forEach(function (img) {

          /*
           * data-src
           */
          if (
            (
              !img.getAttribute('src') ||
              img.getAttribute('src') === ''
            ) &&
            img.dataset.src
          ) {
            img.setAttribute(
              'src',
              img.dataset.src
            );
          }


          /*
           * data-srcset
           */
          if (
            (
              !img.getAttribute('srcset') ||
              img.getAttribute('srcset') === ''
            ) &&
            img.dataset.srcset
          ) {
            img.setAttribute(
              'srcset',
              img.dataset.srcset
            );
          }


          /*
           * data-sizes
           */
          if (
            (
              !img.getAttribute('sizes') ||
              img.getAttribute('sizes') === ''
            ) &&
            img.dataset.sizes
          ) {
            img.setAttribute(
              'sizes',
              img.dataset.sizes
            );
          }


          /*
           * Weitere Lazyload Varianten
           */
          if (
            img.getAttribute('data-original') &&
            !img.getAttribute('src')
          ) {
            img.setAttribute(
              'src',
              img.getAttribute('data-original')
            );
          }


          if (
            img.getAttribute('data-lazy-src') &&
            !img.getAttribute('src')
          ) {
            img.setAttribute(
              'src',
              img.getAttribute('data-lazy-src')
            );
          }


          if (
            img.getAttribute('data-lazy-srcset') &&
            !img.getAttribute('srcset')
          ) {
            img.setAttribute(
              'srcset',
              img.getAttribute('data-lazy-srcset')
            );
          }


          img.classList.remove(
            'lazyload',
            'lazyloading',
            'lazy',
            'loading'
          );

          img.classList.add(
            'lazyloaded'
          );

          img.loading = 'lazy';
        });


      /*
       * <picture> / <source>
       */
      container
        .querySelectorAll('source')
        .forEach(function (source) {

          if (
            (
              !source.getAttribute('srcset') ||
              source.getAttribute('srcset') === ''
            ) &&
            source.dataset.srcset
          ) {
            source.setAttribute(
              'srcset',
              source.dataset.srcset
            );
          }


          if (
            (
              !source.getAttribute('sizes') ||
              source.getAttribute('sizes') === ''
            ) &&
            source.dataset.sizes
          ) {
            source.setAttribute(
              'sizes',
              source.dataset.sizes
            );
          }
        });


      /*
       * Falls das Theme zusätzlich
       * einen eigenen Lazyloader nutzt.
       */
      window.dispatchEvent(
        new Event('resize')
      );

      window.dispatchEvent(
        new Event('scroll')
      );
    }


    /*
     * ==================================================
     * ARTIKEL URL
     * ==================================================
     */

    function getArticleUrl(element) {
      if (!element) {
        return null;
      }

      const links =
        element.querySelectorAll('a[href]');

      for (const link of links) {
        const href =
          link.getAttribute('href');

        if (
          href &&
          href.indexOf('/blogs/') !== -1 &&
          href.indexOf('/tagged/') === -1
        ) {
          return href.split('?')[0];
        }
      }

      return null;
    }


    /*
     * ==================================================
     * ARTIKEL EXTRAHIEREN
     * ==================================================
     */

    function extractArticles(doc) {
      const articles = [];


      /*
       * Featured zuerst.
       *
       * Für Suchergebnisse verwenden wir
       * aber die kleine Kartenvariante.
       */
      const featuredSearchTemplate =
        doc.querySelector(
          '[data-blog-search-featured-template]'
        );

      if (featuredSearchTemplate) {
        const url =
          getArticleUrl(
            featuredSearchTemplate
          );

        if (url) {
          articles.push({
            url: url,

            text:
              normalizeText(
                featuredSearchTemplate.textContent
              ),

            html:
              '<li class="js-pagination-result" data-blog-result>' +
                featuredSearchTemplate.innerHTML +
              '</li>'
          });
        }
      }


      /*
       * Normale Blogkarten.
       */
      const resultsScope =
        doc.querySelector(
          '[data-blog-results]'
        );

      if (resultsScope) {
        resultsScope
          .querySelectorAll(
            '[data-blog-result], .js-pagination-result'
          )
          .forEach(function (element) {

            const url =
              getArticleUrl(element);

            if (!url) {
              return;
            }

            articles.push({
              url: url,

              text:
                normalizeText(
                  element.textContent
                ),

              html:
                element.outerHTML
            });
          });
      }

      return articles;
    }


    /*
     * ==================================================
     * MAXIMALE BLOG-SEITENZAHL
     * ==================================================
     */

    function getMaximumPage(doc) {
      let maximumPage = 1;

      const paginationScope =
        doc.querySelector(
          '[data-blog-pagination-controls]'
        );

      const links =
        paginationScope
          ? paginationScope.querySelectorAll(
              'a[href*="page="]'
            )
          : doc.querySelectorAll(
              'a[href*="page="]'
            );

      links.forEach(function (link) {
        try {
          const url =
            new URL(
              link.href,
              window.location.origin
            );

          const page =
            parseInt(
              url.searchParams.get('page'),
              10
            );

          if (
            !isNaN(page) &&
            page > maximumPage
          ) {
            maximumPage = page;
          }

        } catch (error) {
          /*
           * Ungültige URL ignorieren.
           */
        }
      });

      return maximumPage;
    }


    /*
     * ==================================================
     * ALLE BLOGSEITEN LADEN
     * ==================================================
     */

    async function loadBlogIndex() {
      if (indexLoaded) {
        return blogIndex;
      }

      if (indexLoading) {
        return loadingPromise;
      }

      indexLoading = true;


      if (statusElement) {
        statusElement.textContent =
          'Ratgeber werden geladen …';
      }


      loadingPromise =
        (async function () {

          try {
            const separator =
              blogUrl.indexOf('?') === -1
                ? '?'
                : '&';


            /*
             * Immer Seite 1 laden.
             *
             * Dadurch funktioniert die Suche
             * auch wenn der Besucher gerade
             * auf Seite 2, 3 usw. ist.
             */
            const firstPageUrl =
              blogUrl +
              separator +
              'page=1';


            const response =
              await fetch(
                firstPageUrl,
                {
                  credentials: 'same-origin',
                  cache: 'force-cache'
                }
              );


            if (!response.ok) {
              throw new Error(
                'Blogseite konnte nicht geladen werden.'
              );
            }


            const firstPageHTML =
              await response.text();


            const parser =
              new DOMParser();


            const firstPageDocument =
              parser.parseFromString(
                firstPageHTML,
                'text/html'
              );


            let collectedArticles =
              extractArticles(
                firstPageDocument
              );


            const maximumPage =
              getMaximumPage(
                firstPageDocument
              );


            /*
             * Weitere Blogseiten parallel laden.
             */
            if (maximumPage > 1) {
              const requests = [];


              for (
                let page = 2;
                page <= maximumPage;
                page++
              ) {
                const pageUrl =
                  blogUrl +
                  separator +
                  'page=' +
                  page;


                requests.push(
                  fetch(
                    pageUrl,
                    {
                      credentials: 'same-origin',
                      cache: 'force-cache'
                    }
                  )

                    .then(function (response) {
                      if (!response.ok) {
                        return '';
                      }

                      return response.text();
                    })

                    .then(function (html) {
                      if (!html) {
                        return [];
                      }

                      const pageDocument =
                        parser.parseFromString(
                          html,
                          'text/html'
                        );

                      return extractArticles(
                        pageDocument
                      );
                    })
                );
              }


              const pageResults =
                await Promise.all(
                  requests
                );


              pageResults.forEach(
                function (pageArticles) {
                  collectedArticles =
                    collectedArticles.concat(
                      pageArticles
                    );
                }
              );
            }


            /*
             * Duplikate anhand der Artikel-URL entfernen.
             */
            const uniqueArticles =
              new Map();


            collectedArticles.forEach(
              function (article) {
                if (
                  article.url &&
                  !uniqueArticles.has(
                    article.url
                  )
                ) {
                  uniqueArticles.set(
                    article.url,
                    article
                  );
                }
              }
            );


            blogIndex =
              Array.from(
                uniqueArticles.values()
              );


            indexLoaded = true;


            if (statusElement) {
              statusElement.textContent = '';
            }


            return blogIndex;

          } catch (error) {
            console.error(
              'Blog search:',
              error
            );


            /*
             * Fallback:
             * wenigstens aktuell gerenderte
             * Blogartikel durchsuchen.
             */
            blogIndex =
              extractArticles(
                sectionRoot
              );


            indexLoaded = true;


            if (
              statusElement &&
              searchInput.value.trim()
            ) {
              statusElement.textContent =
                'Die Suche konnte nicht vollständig geladen werden.';
            }


            return blogIndex;

          } finally {
            indexLoading = false;
          }

        })();


      return loadingPromise;
    }


    /*
     * ==================================================
     * HTML ESCAPING
     * ==================================================
     */

    function escapeHTML(value) {
      const div =
        document.createElement('div');

      div.textContent =
        value;

      return div.innerHTML;
    }


    /*
     * ==================================================
     * SUCHERGEBNISSE AUSGEBEN
     * ==================================================
     */

    function renderSearchResults(
      articles,
      query
    ) {
      /*
       * Große Featured Card während
       * einer Suche ausblenden.
       */
      if (featuredCard) {
        featuredCard.style.display =
          'none';
      }


      /*
       * Pagination während Suche ausblenden.
       */
      if (paginationControls) {
        paginationControls.style.display =
          'none';
      }


      resultsContainer.innerHTML = '';


      /*
       * Keine Treffer.
       */
      if (!articles.length) {
        resultsContainer.innerHTML =
          '<li class="blog-search-no-results">' +
            'Keine passenden Ratgeber zu „' +
            escapeHTML(query) +
            '“ gefunden.' +
          '</li>';


        if (statusElement) {
          statusElement.textContent =
            '0 Treffer';
        }

        return;
      }


      const fragment =
        document.createDocumentFragment();


      articles.forEach(
        function (article) {
          const wrapper =
            document.createElement(
              'div'
            );


          wrapper.innerHTML =
            article.html;


          const element =
            wrapper.firstElementChild;


          if (element) {
            element.classList.add(
              'js-pagination-result'
            );

            element.setAttribute(
              'data-blog-result',
              ''
            );

            fragment.appendChild(
              element
            );
          }
        }
      );


      resultsContainer.appendChild(
        fragment
      );


      /*
       * Bilder der dynamisch eingesetzten
       * Karten aktivieren.
       */
      activateBlogImages(
        resultsContainer
      );


      /*
       * Nochmal kurz verzögert,
       * falls das Theme Lazyload später initialisiert.
       */
      setTimeout(
        function () {
          activateBlogImages(
            resultsContainer
          );
        },
        100
      );


      /*
       * Trefferanzahl.
       */
      if (statusElement) {
        statusElement.textContent =
          articles.length +
          ' Treffer';
      }
    }


    /*
     * ==================================================
     * ORIGINALANSICHT WIEDERHERSTELLEN
     * ==================================================
     */

    function restoreOriginalBlog() {
      if (!searchIsActive) {
        if (statusElement) {
          statusElement.textContent = '';
        }

        clearButton.hidden = true;

        return;
      }


      resultsContainer.innerHTML =
        originalResultsHTML;


      if (featuredCard) {
        featuredCard.style.display =
          originalFeaturedDisplay;
      }


      if (paginationControls) {
        paginationControls.style.display =
          originalPaginationDisplay;
      }


      if (statusElement) {
        statusElement.textContent = '';
      }


      clearButton.hidden = true;

      searchIsActive = false;


      activateBlogImages(
        resultsContainer
      );
    }


    /*
     * ==================================================
     * SUCHE
     * ==================================================
     */

    let searchTimer = null;


    async function performSearch() {
      /*
       * Versionsnummer.
       *
       * Verhindert, dass eine alte asynchrone
       * Suche später eine neuere überschreibt.
       */
      const currentVersion =
        ++searchVersion;


      const rawQuery =
        searchInput.value.trim();


      const query =
        normalizeText(
          rawQuery
        );


      /*
       * Leeres Feld:
       * normale Blogansicht zurück.
       */
      if (!query) {
        restoreOriginalBlog();
        return;
      }


      /*
       * Zustand nur beim Eintritt in
       * die Suche speichern.
       */
      if (!searchIsActive) {
        captureOriginalState();
        searchIsActive = true;
      }


      clearButton.hidden = false;


      const articles =
        await loadBlogIndex();


      /*
       * Während des Ladens wurde eventuell
       * bereits eine neue Suche gestartet.
       */
      if (
        currentVersion !== searchVersion
      ) {
        return;
      }


      const currentInput =
        normalizeText(
          searchInput.value.trim()
        );


      if (
        currentInput !== query
      ) {
        return;
      }


      /*
       * Mehrere Suchbegriffe:
       *
       * "pendelleuchte esstisch"
       *
       * Beide Begriffe müssen vorkommen.
       */
      const searchTerms =
        query
          .split(' ')
          .filter(Boolean);


      const matches =
        articles.filter(
          function (article) {
            return searchTerms.every(
              function (term) {
                return article.text.includes(
                  term
                );
              }
            );
          }
        );


      renderSearchResults(
        matches,
        rawQuery
      );
    }


    /*
     * ==================================================
     * EINGABE
     * ==================================================
     */

    searchInput.addEventListener(
      'input',
      function () {
        clearTimeout(
          searchTimer
        );


        searchTimer =
          setTimeout(
            performSearch,
            250
          );
      }
    );


    /*
     * ==================================================
     * ENTER
     *
     * Wichtig:
     * Boost darf hier keine Suche übernehmen.
     * ==================================================
     */

    searchInput.addEventListener(
      'keydown',
      function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();

          event.stopPropagation();

          event.stopImmediatePropagation();


          clearTimeout(
            searchTimer
          );


          performSearch();
        }
      }
    );


    /*
     * ==================================================
     * SUCHE LÖSCHEN
     * ==================================================
     */

    clearButton.addEventListener(
      'click',
      function () {
        /*
         * Noch laufende alte Suche ungültig machen.
         */
        searchVersion++;


        clearTimeout(
          searchTimer
        );


        searchInput.value = '';


        restoreOriginalBlog();


        searchInput.focus();
      }
    );
  }


  /*
   * ==================================================
   * ALLE BLOG-SECTIONS INITIALISIEREN
   * ==================================================
   */

  function initAllBlogSearches(root) {
    const scope =
      root || document;


    /*
     * Falls root selbst die Blog-Section ist.
     */
    if (
      scope.matches &&
      scope.matches('[data-blog-section]')
    ) {
      initBlogSearch(scope);
    }


    /*
     * Blog-Sections innerhalb des Bereichs.
     */
    if (scope.querySelectorAll) {
      scope
        .querySelectorAll('[data-blog-section]')
        .forEach(function (sectionRoot) {
          initBlogSearch(
            sectionRoot
          );
        });
    }
  }


  /*
   * ==================================================
   * NORMALE SEITE
   * ==================================================
   */

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initAllBlogSearches(
          document
        );
      }
    );

  } else {
    initAllBlogSearches(
      document
    );
  }


  /*
   * ==================================================
   * SHOPIFY THEME EDITOR
   *
   * Wenn die Section im Editor neu geladen wird,
   * Suche erneut initialisieren.
   * ==================================================
   */

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initAllBlogSearches(
        event.target
      );
    }
  );

})();